<template>
    <div>
        <div class="vx-row">
            <vs-card>
                <div slot="header">
                    <h5>Plainte reçu par mail et par ccmt</h5>
                </div>
                <vs-row>
                    <div class="flex -mx-2">
                        <div class="w-2/4 px-2">
                            <span class="vs-select--label">Période</span>
                            <date-range-picker
                                ref="picker"
                                :opens="opens"
                                :locale-data=locale
                                :singleDatePicker="false"
                                :timePicker=false
                                :showWeekNumbers="showWeekNumbers"
                                :showDropdowns="showDropdowns"
                                :autoApply="autoApply"
                                v-model="dateRange"
                                :ranges=false
                                @update="updateValues"
                                :linkedCalendars="linkedCalendars"
                                :dateFormat="dateFormat"
                                :always-show-calendars="false"
                                :alwaysShowCalendars="alwaysShowCalendars"
                                class="vs-inputx vs-input--input"
                            >
                                <div slot="input" slot-scope="picker" style="min-width: 350px;">
                                {{ picker.startDate | date }} - {{ picker.endDate | date }}
                                </div>
                            </date-range-picker>
                        </div>
                        <div class="w-3/4 px-2">
                            <span>Selectionner le canal</span>
                            <v-select v-model="canal" class="w-full" label="name"
                                placeholder="Sélectionner un canal"
                                :reduce="user => user.id"
                                :options="[{name: 'CCMT', id: 'ccmt'}, {name: 'MAIL', id: 'mail'}]">
                            </v-select>
                        </div>
                        <div class="w-1/8 px-2">
                            <vs-button :disabled="canal === '' || dateRange.startDate === '' || dateRange.endDate === ''" @click="makeSearch()" style="margin-top: 18px;" color="primary"
                                        type="filled" icon="search">Recherche
                            </vs-button>
                        </div>
                    </div>
                </vs-row>
            </vs-card>
        </div>
    </div>
    
</template>
<script>
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import moment from "moment";
import axios from "axios";
export default {
    name : "totalRequest",
    components: {DateRangePicker},
    data: () => ({
        canal: '',
        opens: 'right',
        showWeekNumbers: true,
        linkedCalendars: true,
        alwaysShowCalendars: true,
        showDropdowns: true,
        autoApply: false,
        locale: {
            direction: 'ltr',
            format: 'dd/mm/yyyy',
            separator: ' - ',
            applyLabel: 'Appliquer',
            cancelLabel: 'Annuler',
            weekLabel: 'W',
            customRangeLabel: 'Custom Range',
            daysOfWeek: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
            monthNames: ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Jui', 'Juil', 'Aou', 'Sep', 'Oct', 'Nov', 'Dec'],
            firstDay: 0
        },
        dateRange: {
            startDate: "",
            endDate: "",
        },
        dateFormat(classes, date) {
            let yesterday = moment().subtract(1, 'day');
            if (!classes.disabled) {
            }
        return classes
        },
    }),
    mounted(){
        this.dateRange.startDate = moment(new Date()).format('YYYY-MM-DD')
        this.dateRange.endDate = moment(new Date()).format('YYYY-MM-DD')
    },
    methods:{
        updateValues(values) {
            this.dateRange.startDate = moment(values.startDate).format('YYYY-MM-DD');
            this.dateRange.endDate = moment(values.endDate).format('YYYY-MM-DD');
        },
        
        makeSearch() {
            this.$vs.loading()
            axios({
            url: '/cex/request-with-canal',
            method: 'POST',
            data: {
                date_debut: this.dateRange.startDate,
                date_fin: this.dateRange.endDate,
                canal: this.canal
            },
            responseType: 'blob',
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'requestCanal.xlsx')
                document.body.appendChild(link)
                link.click()
                this.category = ''
                this.$vs.loading.close()
            }).catch((error) => {
                this.error_base = error.response.data.errors
                this.$vs.loading.close()
                if (error.response.status === 401) {
                    this.$vs.notify({
                    title: 'Erreur',
                    text: 'Votre session a expiré',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-check',
                    position: 'top-right'
                    })
                    this.$router.push({name: "login"})
                }
            })
        },
    }
}
</script>

<style lang="scss">
  @import "@/assets/scss/vuesax/components/vxTimeline.scss";
</style>